import type { ColumnDef } from '@tanstack/react-table';
import type { File } from '../../../../types/file.types';

export const CommentColumn: ColumnDef<File> = {
  id: 'comment',
  accessorFn: (row) => row.comment,
  header: 'Commentaire',
  enableSorting: false,
  enableHiding: false,
  cell: (props) => {
    const comment = props.getValue() as string;
    return (
      <p
        className="truncate text-center text-sm"
        data-tooltip-content={comment}
        data-tooltip-id="tooltip"
        data-tooltip-place="top"
        data-tooltip-delay-show={100}
        data-tooltip-offset={5}
      >
        {comment.toString()}
      </p>
    );
  },
  size: 250,
};
